import { QueryClientProvider } from '@tanstack/react-query';
import { useLoaderData } from 'react-router';
import { featureFlagGuardLoader } from '@/feature-flags/feature-flag-guard-loader';
import { flags } from '@/feature-flags/flags';
import { queryClient } from '@/react-query/react-query-instance';
import { getPageMeta } from '@/routes-utils/get-page-meta';
import {
  getPageScreenshotUrl,
  getPageScreenshotVersion,
} from '@/routes-utils/page-screenshot-url';
import { SeoHandle } from '../sitemap[.]xml/generate-sitemap';
import { Route } from './+types/route';
import { graphClientLoader } from './client-loader';
import { GraphProvider } from './sigma-graph/graph-provider';
import { XGraph } from './x-graph';

export const clientLoader = featureFlagGuardLoader(graphClientLoader, {
  flag: flags.twitterGraph,
});

export const meta = ({ location }: Route.MetaArgs) => {
  return getPageMeta({
    title: 'Synoptic: CT Network Visualization',
    previewDescription:
      'The graph contains data of the most influential users in the CT network and the relationships between them',
    previewImage: getPageScreenshotUrl({
      type: 'ct',
      id: 'graph',
      version: getPageScreenshotVersion(location.search),
      w: 1200,
      h: 630,
      routeSearchParams: location.search,
    }),
    previewImageW: 1200,
    previewImageH: 630,
    url: `https://synoptic.com` + location.pathname + location.search,
    twitterCreator: '@SynopticCom',
  });
};

export const handle: SeoHandle = {
  sitemap: true,
};

export default function XGraphRoute() {
  const { nodes, edges } = useLoaderData<typeof clientLoader>();

  return (
    <QueryClientProvider client={queryClient}>
      <GraphProvider nodes={nodes} edges={edges}>
        <XGraph nodesData={nodes} />
      </GraphProvider>
    </QueryClientProvider>
  );
}
